import { Link } from '@tanstack/react-router'
import { Sparkles } from 'lucide-react'
import { db } from '@/runtime'
import { useServer } from '@/state/server'
import { useLiveQuery } from 'dexie-react-hooks'
import { META } from '@/db/schema'

const LOADING = Symbol('loading')
const NONE = Symbol('none')

/**
 * What changed in the build you are now running, on Today, once. The push
 * notification says the same thing, but a notification can be swiped away or
 * never allowed; this does not depend on one.
 */
export const WhatsNew = ({ hideFor = false }: { hideFor?: boolean }) => {
  // the build comes from the app's own version check (start and every foreground),
  // not a fetch of our own that could fire before sign-in has finished
  const version = useServer((s) => s.version)
  const note = useServer((s) => s.note)
  // a missing row and a row still loading must not look alike, or a device that
  // has never pressed Got it never sees a card: the query itself says "none"
  const seenRow = useLiveQuery(async () => (await db.meta.get(META.seenRelease)) ?? NONE, [], LOADING)
  if (seenRow === LOADING || hideFor) return null
  if (!version || version === 'dev' || !note) return null
  const seen = seenRow === NONE ? undefined : (seenRow.value as string | undefined)
  if (seen === version) return null
  const build = { version, note }
  return (
    <div className="card px-3.5 py-3 mb-3" data-testid="whats-new">
      <div className="flex items-center gap-2 text-[13px] font-semibold text-accent-text mb-1">
        <Sparkles size={14} aria-hidden />
        New in this version
      </div>
      <p className="text-[15px] leading-snug">{build.note}</p>
      <div className="mt-2 flex items-center gap-4">
        <Link to="/whats-new" className="text-xs text-muted hover:text-fg" data-testid="whats-new-open">
          See what&rsquo;s new
        </Link>
        <button
          type="button"
          onClick={() => void db.setMeta(META.seenRelease, build.version)}
          className="text-xs text-faint hover:text-fg min-h-8"
          data-testid="whats-new-dismiss"
        >
          Got it
        </button>
      </div>
    </div>
  )
}
